module.exports = __webpack_public_path__ + "img/pass.f601ebc4.png";